<template>
  <div class="lease-carousel position-relative">
    <div v-if="loadingLeases" class="justify-content-center text-center p-3">
        <b-spinner />
    </div>
    <div v-else>
      <div v-if="currentLeases.length > 0">

        <h6>Choose Lease</h6>
        <p>This is the default payment that will be used to pay-off the lease you choose below.</p>
        <b-carousel
        :value="currentIndex"
        @input="onSlideChange"
        controls
        indicators=""
        background="#fff"
        :interval="0"
        class="w-100"
        touch
        >
        <b-carousel-slide
            v-for="(lease, idx) in currentLeases"
            :key="lease.id"
            class="lease-slide"
        >
            <template #img>
                <div
                class="lease-slide-content"
                :class="{selected: lease.id === selectedLease?.id}"
                @click="selectLease(lease)"
                >
                <div class="lease-slide__info">
                    <div><strong>{{ $t('Contract Number') }}:</strong> {{ lease.loan_number }}</div>
                    <div><strong>{{ $t('Contract Date') }}:</strong> <fn-format-date format="MM/DD/YYYY" :value="lease.application_date" :ignore-time-zone="true"></fn-format-date></div>
                    <div><strong>{{ $t('Store') }}:</strong> {{ lease.store_name }}</div>
                </div>
                <div class="lease-slide__coapplicant">
                    <label :class="{'disabled': !lease.hasCoapplicant}">
                    <input type="checkbox" :checked="isCoapplicant(lease)" :disabled="!lease.hasCoapplicant || currentLeases.length === 1" @change.stop="toggleCoapplicant(lease.id)" />
                    {{ $t('I am the coapplicant') }}
                    </label>
                </div>
                </div>
            </template>
        </b-carousel-slide>
        </b-carousel>
        <div class="carousel-dots mt-2 d-flex justify-content-center">

            <div v-if="currentLeases.length <= 5">
                <span
                    v-for="(lease, idx) in currentLeases"
                    :key="lease.id"
                    class="dot"
                    :class="{active: idx === currentIndex}"
                    @click="goToSlide(idx)"
                ></span>

            </div>
            <span v-else>{{ currentIndex + 1 }} of {{ currentLeases.length }}</span>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import LeaseDetails from "../../leases/mixins/leaseDetails";

export default {
  name: "LeaseCarousel",
  mixins: [LeaseDetails],
  data() {
    return {
      currentIndex: 0,
      selectedLease: null,
      coapplicantMap: { 1: false, 2: false },
      mockLeases: false
    }
  },
  computed: {
    canGoPrev() {
      return this.currentIndex > 0;
    },
    canGoNext() {
      return this.currentIndex < this.currentLeases.length - 1;
    }
  },
  watch: {
    selectedLease(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    onSlideChange(idx) {
      this.currentIndex = idx;
      this.selectLease(this.currentLeases[idx]);
    },
    goToSlide(idx) {
      this.currentIndex = idx;
    },
    selectLease(lease) {
      this.selectedLease = lease;
    },
    toggleCoapplicant(id) {
      if (this.currentLeases.length === 1) return;
      this.$set(this.coapplicantMap, id, !this.coapplicantMap[id]);
    },
    isCoapplicant(lease) {
      return !!this.coapplicantMap[lease.id];
    }
  }
}
</script>

<style scoped>
.lease-carousel {
  position: relative;
}
.lease-slide-content {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 1rem;
  min-width: 250px;
  background: #fff;
  cursor: pointer;
}
.lease-slide-content.selected {
  border: 2px solid #28a745;
}
.lease-slide__info {
  margin-bottom: 0.5rem;
  margin-left: 30px;
}
.lease-slide__coapplicant {
  text-align: left;
  margin-left: 30px;
}
.lease-slide__coapplicant label.disabled {
  color: #aaa;
}
.carousel-dots {
  gap: 8px;
}
.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
  display: inline-block;
  cursor: pointer;
  transition: background 0.2s;
}
.dot.active {
  background: #28a745;
}
.lease-slide.disabled {
  opacity: 0.6;
  pointer-events: none;
}
:deep(.carousel-control-prev-icon),
:deep(.carousel-control-next-icon) {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(200deg);
}
</style>